// extracted by mini-css-extract-plugin
module.exports = {"navigationLoggedIn":"LeftSidebarLoggedInDesktopMode_navigationLoggedIn__SpN0G","logo":"LeftSidebarLoggedInDesktopMode_logo__1_yop"};